import { t } from 'ember-intl';

<template>
  <h1 class="sr-only">{{t "page_headings.repaying_student_debt"}}</h1>
</template>
